module.exports = __webpack_public_path__ + "static/media/auto-forum.60b48435.png";